import TokenManager from "../../utils/storage/TokenManager";

const getDomain = () => {
	const env = document.location.hostname;
	let domain = '';

	switch (env) {
		case 'localhost':
			domain = 'http://localhost:3000'
			break
		case 'partner-test.roscolive.com':
			domain = 'https://test.roscolive.com'
			break
		case 'partner-dev.roscolive.com':
			domain = 'https://dev.roscolive.com'
			break
		case 'partner-stage.roscolive.com':
			domain = 'https://staging.roscolive.com'
			break
		case 'partner-canada.roscolive.com':
			domain = 'https://canada.roscolive.com'
			break
		case 'roscocloud.com':
		case 'www.roscocloud.com':
		case 'partner.roscolive.com':
			domain = 'https://fleet.roscolive.com'
			break
		default:
			break
	}

	return domain;
}

// export async function redirectToRoscoLive(argType, argCompanyId, argEntityId = null) {
// 	let url = `${getDomain()}/permalink/partner/${argType}/${argCompanyId}`;
// 	const a_t = await TokenManager.getAccessToken();
// 	const r_t = await TokenManager.getRefreshToken();
// 	if (argEntityId) {
// 		url += `/${argEntityId}`
// 	}
// 	url += `/#a_t=${encodeURIComponent(a_t)}&r_t=${encodeURIComponent(r_t)}`
// 	window.location.assign(url)
// }

export async function redirectToRoscoLive(argType, argCompanyId, argEntityId = null) {
	let url = `${getDomain()}/permalink/partner/${argType}/${argCompanyId}`;
	const s_t = await TokenManager.getSessionToken();
	if (argEntityId) {
		url += `/${argEntityId}`
	}
	url += `/#s_t=${encodeURIComponent(s_t)}`
	window.location.assign(url)
}
